import styled from '@emotion/styled';

const InputButton = styled.button`
  width: 300px;
  height: 30px;
  margin-bottom: 10px;
  background: url(images/button.png) repeat-x scroll 50% 50%;
  background-size: contain;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  box-shadow: 1px 1px 2px #ccc;

  &:hover {
    filter: brightness(1.02);
  }

  &:focus {
    border: 1px solid #666;
  }
`;

interface ButtonProps {
  displayName: string;
  onClick: () => void;
  id?: string;
}

export function StyledLoginButton({ displayName, onClick, id }: ButtonProps) {
  return (
    <InputButton id={id} onClick={onClick}>
      {displayName}
    </InputButton>
  );
}
